import { Commit } from 'vuex';
import { Route } from 'vue-router';
import util from '@/libs/util';
import { IAPPSTATE, IOpenTag } from '../state.d';
import { APP } from '../mutation_types';

const openPage: Function = (context: { commit: Commit, state: IAPPSTATE },
  route: Route) => {
  context.commit(APP.SET_APP_OPEN_TAGS, util.openPage(context.state.openTags, route));
};

const closePage: Function = (context: { commit: Commit, state: IAPPSTATE },
  param: { type: string, path: string }) => {
  context.commit(APP.SET_APP_OPEN_TAGS, util.closePage(context.state.openTags, param));
  return context.state.openTags.find((tag: IOpenTag) => tag.active);
};

export default {
  openPage,
  closePage,
};
